import React from 'react';
import { Alert, Linking, Pressable, View } from 'react-native';
import { faEnvelope, faGlobe, faPhone } from '@fortawesome/pro-regular-svg-icons';
import useTranslation from '../../../hooks/translation-hook';
import { AtHomeContacts, AtHomeContactRequirements, getAtHomeContactLinks } from '../../../models/helpers/remoteMissions';
import MissionCompensationRow from './MissionCompensationRow';

const icons = { phone: faPhone, email: faEnvelope, website: faGlobe };

interface AtHomeContactActionsProps {
  contacts: AtHomeContacts;
  requirements: AtHomeContactRequirements;
}

const AtHomeContactActions = ({ contacts, requirements }: AtHomeContactActionsProps) => {
  const t = useTranslation();
  const links = getAtHomeContactLinks(contacts, requirements);
  if (!links.length) return null;

  const open = async (url: string) => {
    try {
      await Linking.openURL(url);
    } catch {
      Alert.alert(t('error'), t('Something-went-wrong-please-try-again-later'));
    }
  };

  return <View style={{ width: '100%', minWidth: 0 }}>
    {links.map(link => <Pressable key={link.kind} accessibilityRole="link"
      accessibilityLabel={`${t(link.label)}: ${link.value}`}
      onPress={() => open(link.url)}
      style={{ minHeight: 44, width: '100%' }}>
      <MissionCompensationRow icon={icons[link.kind]} separator heading={t(link.label)}
        caption={link.value} underlineCaption />
    </Pressable>)}
  </View>;
};

export default AtHomeContactActions;
